var map = {
	"./default.svg": "./src/images/cursors/ARROW/default.svg",
	"./hover.svg": "./src/images/cursors/ARROW/hover.svg",
	"./preview_1.svg": "./src/images/cursors/ARROW/preview_1.svg",
	"./preview_2.svg": "./src/images/cursors/ARROW/preview_2.svg",
	"./project_hover.svg": "./src/images/cursors/ARROW/project_hover.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/cursors/ARROW sync recursive ^\\.\\/.*\\.svg$";